export function getLanguageCode(locale: string) {
    const parts = locale.split('-');
    return parts.length === 2 ? parts[0] : locale;
}